/** Build Labs public URLs when API does not return public_url/detail_url (local dev). */
export function publicJobDetailUrl(slug: string): string {
  const id = slug.trim()
  if (!id) return ''
  if (typeof window !== 'undefined') {
    return `${window.location.origin}/jobs/${encodeURIComponent(id)}`
  }
  return `/jobs/${encodeURIComponent(id)}`
}

export function publicOrganisationUrl(slug: string): string {
  const id = slug.trim()
  if (!id) return ''
  if (typeof window !== 'undefined') {
    return `${window.location.origin}/o/${encodeURIComponent(id)}`
  }
  return `/o/${encodeURIComponent(id)}`
}

export function publicProfileUrl(slug: string): string {
  const id = slug.trim()
  if (!id) return ''
  if (typeof window !== 'undefined') {
    return `${window.location.origin}/p/${encodeURIComponent(id)}`
  }
  return `/p/${encodeURIComponent(id)}`
}

/** Labs-origin URL for a published managed job — same slug-based pattern as `publicProfileUrl`. */
export function publishedJobPublicUrl(
  publicationStatus: string | undefined,
  publicSlug: string | null | undefined,
): string {
  if (publicationStatus !== 'published') return ''
  return publicJobDetailUrl(publicSlug ?? '')
}
